import type { IGetEnglishIqDemoV1Response } from '../getEnglishIqDemoV1';
import { getEnglishIqDemoV1ResponseSchema } from '../getEnglishIqDemoV1';

export const updateEnglishIqDemoV1ResponseSchema = getEnglishIqDemoV1ResponseSchema;

export type IUpdateEnglishIqDemoV1Response = IGetEnglishIqDemoV1Response;
